import {Component, EventEmitter, Inject, Input, Output} from 'ng-metadata/core';

let isEmpty = require('lodash/isEmpty');
const get = require('lodash/get');
import {BriefResultService} from '../../briefResult/briefResult.service';
import {FacetService} from '../../facet/facet.service';
import {SearchService} from '../../search.service';
import {SearchFieldsService} from '../../search.fields.service';
import {FavoritesService} from '../../../favorites/favorites.service';
import {EndlessScrollingUtil} from '../../../nddUtils/endlessScollingUtil.service';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {isBrowserIE} from '../../../infra/browserSniffer';
import {
    getAttributesMap,
    getResultsBulkSize,
    getScopeList,
    getSuspendWatchersActivatedForBrowser,
    getResultsNumberToDisableSuspendWatchers
} from '../../../appConfig/appConfigForward';
import {TabsAndScopesSelectorService} from '../../searchBar/tabsAndScopesSelector/tabsAndScopesSelector.service';
import {SmoothScrollUtil} from '../../../nddUtils/smoothScrollUtil.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {JournalsService} from '../../../journals/journals.service';
import {SearchErrorMessageService} from '../errorMessage/searchErrorMessage.service';
import {PageNavMenuService} from './pageNavMenu/pageNavMenu.service';
import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
import {DatabasesService} from "../../../journals/databases.service";
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {DatabasesCategorizeService} from "../../../journals/databasesCategorize/databasesCategorize.service";
import {MediaQueries} from '../../../infra/mediaQueries.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {PhysicalBestOfferService} from "../../fullView/ngrs/physicalBestOffer/physicalBestOffer.service";
import {NgrsService} from '../../fullView/ngrs/ngrs.service';
import {OrgListCategorizeService} from "../../../journals/orgListCategorize/orgListCategorize.service";
import {OrganizationOrFacetToggleService} from "../../../journals/organizationOrFacetToggle/organization-or-facet-toggle.service";
import {SearchStateService} from "../../searchState.service";
import {ResultUtil} from "../../../nddUtils/resultUtil.service";
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service'

const isArray = require('lodash/isArray');
const memoize = require('lodash/memoize');
const some = require('lodash/some');

@Component({
    selector: 'prm-search-result-list',
    templateUrl: 'components/search/searchResult/searchResultList/search-result-list.html',
})


export class PrmSearchResultList {

    public categoryDisplayValue: string;
    private _currentPage = 0;
    private expandedItemIndex = -1;
    private expandedItem;
    private initialOffset = 0;
    private isIe = isBrowserIE();
    private digestWhenInViewConfigured: boolean;
    // private PAGE_SIZE = getResultsBulkSize();
    private expandedItemHeight: string;
    private pagingConfigutation: {};
    private _totalResultVersion: number = 0;
    private wasInFullDisplay: boolean = false;
    private scopes = getScopeList();
    private testisOpen: boolean = false;
    private showTimer = false;
    private listBottomSpacer: boolean = false;
    private isJournalCategories: boolean;
    private toggleMode: boolean = false;
    private dialogInView: boolean = false;
    private uiType: string = "widget";

    @Input() private categoriesType: string;
    @Input() itemlist: Object[];
    @Input() isFavorites: boolean;
    @Input() isSavedQuery: boolean;
    @Input() isSearchHistory: boolean;
    @Input() links: string[];
    @Input() facetToLeft: boolean;
    @Input() featuredResult;
    @Input() query: string;


    @Output() private showDialogEvent = new EventEmitter<Object>();
    @Output() private hideDialogEvent = new EventEmitter<Object>();

    constructor(private briefResultService: BriefResultService,
                private searchService: SearchService,
                private searchFieldsService: SearchFieldsService,
                private facetService: FacetService,
                private pnxUtil: PnxUtil,
                private favoritesService: FavoritesService,
                private endlessScrollingUtil: EndlessScrollingUtil,
                private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
                private primolyticsService: PrimolyticsService,
                private jwtUtilService: JwtUtilService,
                private databasesService: DatabasesService,
                private mediaQueries: MediaQueries,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private searchErrorMessageService: SearchErrorMessageService,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$state') private $state: ng.ui.IStateService,
                private journalsService: JournalsService,
                private newspapersService: NewspapersService,
                private databasesCategorizeService: DatabasesCategorizeService,
                @Inject('$location') private $location: ng.ILocationService,
                private pageNavMenuService: PageNavMenuService,
                @Inject('searchBoxIcons') private searchBoxIcons,
                private physicalBestOfferService: PhysicalBestOfferService,
                private configurationUtil: ConfigurationUtil,
                private ngrsService: NgrsService,
                private orgListService: OrgListCategorizeService,
                private searchStateService: SearchStateService,
                private organizationOrFacetService: OrganizationOrFacetToggleService,
                private resultUtil: ResultUtil,
                private mtCache: MappingTablesCache) {

        this.$timeout(() => {
            this.showTimer = true;
        }, 2000);
        this.briefResultService = briefResultService;
        this.briefResultService.resetIsChosen();
        this.briefResultService.buildJsonOdIdsAndPins();
        if (searchService.getSearchObject() && searchService.getSearchObject().offset) {
            this.initialOffset = searchService.getSearchObject().offset - (searchService.getSearchObject().offset % this.pageSize); //we round down to offset of beginning of nearest page
        }
        this.pageInView = Math.floor((this.$stateParams['offset'] || 0) / this.pageSize) + 1; //init page in view to the first loaded page
        this.pageNavMenuService.needToUpdatePivInSafari = false;
        this.isJournalCategories = this.setJournalCategoriesByConfiguration();
        this.physicalBestOfferService.resetResultsObject();
        this.ngrsService.resetNgrsVisibilityResponse();
        this.digestWhenInViewConfigured = (getSuspendWatchersActivatedForBrowser() === "ALL") || (getSuspendWatchersActivatedForBrowser() === "IE" && isBrowserIE());
    }


    ngOnInit() {
        this.$scope.$watch(() => this.itemlist, (newVal, oldVal) => {
            if (newVal) {
                newVal.forEach((e) => {
                    if (e.context === 'MetaLib') {
                        this.uiType = "widget";
                        this.pagingConfigutation = {
                            firstPage: false,
                            paging: false
                        }
                    }
                });
            }
            this._totalResultVersion = this.recordsNumberInludeFrbr;

        });

        this.uiType = "widget";


        if (this.resultUtil.isResultsPerPageEnabled()) {
            this.uiType = "picker";
        }

        if (this.isOrganizationListState()) {
            this.uiType = "widget";
        }
        this.enrichCategoriesTermTranslations();
    }

    get isDigestWhenInViewDisabled() {
        return this.itemlist.length <= getResultsNumberToDisableSuspendWatchers();
    }

    get pageSize() {
        return this.resultUtil.updatedBulkSize;
    }

    get indeterminateState() {
        if (this.briefResultService.checkIfAllSelected() || this.briefResultService.getChosenRecords().length === 0) {
            return false;
        }
        return true;

    }

    public getAriaChecked() {
        if (this.briefResultService.checkIfAllSelected()) {
            return 'true';
        } else if (this.briefResultService.getChosenRecords().length === 0) {
            return 'false';
        }
        return 'mixed';

    }

    get categoryResultCode() {
        if (this.categoriesType == 'db')
            return 'dbcategories.results';
        if (this.categoriesType == 'journal')
            return 'nui.journalsearch.category.result';
        else
            return 'result';
    }


    get allIn() {
        return this.briefResultService.checkIfAllSelected() ? true : false;
    }

    public showFeaturedResults(index: number): boolean {
        if (!this.featuredResult) {
            return false;
        }
        if (this.itemlist.length === 0) {
            return false;
        }
        if (this.itemlist.length == 1 || (this.itemlist.length == 2 && index == 1)) {
            return true;
        } else {
            if (index == 2) {
                return true;
            }
        }
        return false;

    }

    public selectOrUnselectAll() {
        this.briefResultService.selectAll = !this.allIn;
        this.briefResultService.chooseAll();
    }

    public enableToolBar() {
        this.briefResultService.enableOrDisableToolBar = true;
        this.toggleMode = true;
    }

    public disableToolBar($event) {
        this.briefResultService.enableOrDisableToolBar = false;
        this.toggleMode = false;
    }

    public isFetchingAllItems() {
        return this.favoritesService.isFetchingAllItems;
    }


    private get isAtozSearch() {
        return this.journalsService.isJournalSearch() || this.databasesService.isDBSearch();
    }

    private get isNewspapersSearch() {
        return this.newspapersService.isNewspapersSearch();
    }


    get totalResultVersion(): number {
        return this._totalResultVersion;
    }

    private firstInPage(index) {
        return (index === 0) || ((index % this.itemsPerPage) === 0)
    }


    public shouleFeaturedResultsApear(): boolean {
        if (this.itemlist.length === 0 || this.featuredResult === undefined || this.featuredResult.featuedResultsItems.length < 4) {
            return false;
        } else {

        }


        return true;
    }

    private detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm) {
            return true;
        }
        return false;
    }

    private enrichCategoriesTermTranslations() {
        let categoryTerm = this.categoryTerm;
        let defaultCategoryTerm = this.getDefaultTerm();

        this.$translate(categoryTerm, [], '', defaultCategoryTerm).then((translation) => {
            this.categoryDisplayValue = translation;
        });
    }

    private lastInPage(index) {
        return ((index % this.itemsPerPage) === (this.itemsPerPage - 1));
    }

    private calcPage(index) {
        return 1 + this.getItemOffset(index) / this.itemsPerPage;
    }

    private get currentPage() {
        return this._currentPage + 1;
    }

    private set currentPage(page) {
        this._currentPage = page - 1;
    }

    private get itemsPerPage() {
        return this.pageSize;
    }

    private isDisabled() {
        return this.searchInProgress;
    }


    private offset() {
        return this.searchService.getSearchObject().offset - (this.searchService.getSearchObject().offset % this.pageSize); //we round down to offset of beginning of nearest page
    }

    private from() {
        return this.offset() + 1;
    }

    private to() {
        return this.searchService.getSearchObject().to
    }


    private get selectedItem() {
        return this.searchService.getSelectedItem();
    }

    private get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }


    private get imagesBarFillersList() {
        return this.searchService.getResultObject().images;
    }


    private get searchResults() {
        return this.searchService.getResultObject().data;
    }

    private get resultsExists() {
        return !(isEmpty(this.searchService.getResultObject().info));
    }

    public isShowMoreResultButton() {
        let info = this.searchService.getResultObject().info;
        return this.resultsExists && Number(info.last) < info.total;
    }

    public isShowFetchMoreResultButton() {
        let info = this.searchService.getResultObject().info;
        return this.resultsExists && info.total < info.maxTotal;
    }

    private get searchInfo() {
        return this.searchService.getResultObject().info;
    }

    private get searchString() {
        return this.searchService.searchFieldsService._mainSearch;
    }

    private get didUMean() {
        return this.searchService.getResultObject().didUMean;
    }

    private get controlledVocabulary() {
        return get(this, ['searchInfo', 'controlledVocabulary']);
    }

    private get errorCode() {
        let info = this.searchInfo;
        if (info && info.errorDetails) {
            if (this.searchInfo.errorDetails.errorCode === 'controlled.voc.synonym' ||
                this.searchInfo.errorDetails.errorCode === 'search.error.ui.server.not_authorized') {
                return null;
            }
            return this.searchInfo.errorDetails.errorCode;
        }
        return null;
    }

    private get errorMessage() {
        let info = this.searchInfo;
        if (info && info.errorDetails) {
            return this.searchInfo.errorDetails.errorMessages;
        }
        return null;

    }

    private get explainMessage() {
        let info = this.searchInfo;
        if (info && info.explain) {
            return this.searchInfo.explain.errorMessages[0];
        }
        return null;
    }

    private getLength() {
        let info = this.searchInfo;
        if (info) {
            return info.total;
        } else {
            return 2;
        }
    }

    private get totalItems() {
        return this.getLength();
    }

    private getItemAtIndex(index) {
        return this.searchService.getItemAtIndex(index);

    }

    private getNgRepeatItemId(item, index) {
        return item.pnx.control.recordid[0] + '-' + index;
    }

    private showPin(item) {
        return this.briefResultService.getShowPinForRecordId(item.pnx.control.recordid[0]);
    }

    private hasNextResults() {
        return this.searchService.needToGetNextResults();
    }

    /**
     * @ngdoc method
     * @name nextResults
     * @methodOf starter.controller:SearchController
     * @description
     * Gets the next bulk of search results of the current search
     */
    private nextResults() {
        if (!this.endlessScrollingUtil.isSearchEndlessScrollingEnabled) { //if endless scrolling was disabled do nothing
            return;
        }

        if (this.searchService.needToGetNextResults()) {
            this.callSearchServiceNextResultsWithBeacon();
        } else {
            this.callSearchServiceNextResults();
        }
        if (this.resultUtil.isResultsPerPageEnabled() && this.uiType == "picker") {
            this.briefResultService.resetIsChosen();
        }
        if (this.resultUtil.isResultsPerPageEnabled() && this.uiType == "picker"
            && this.searchService.getSearchObject() && this.searchService.getSearchObject().offset > 0) {
            this.initialOffset = this.searchService.getSearchObject().offset - (this.searchService.getSearchObject().offset % this.pageSize); //we round down to offset of beginning of nearest page
        }
    }

    private jumpToPage(p) {
        let page = p - 1;
        this.searchService.jumpToPage(page);
        this._currentPage = page;
    }

    @beacon({'p': 'brief', 'op': 'next'})
    private callSearchServiceNextResultsWithBeacon() {
        this.callSearchServiceNextResults();
    }

    private callSearchServiceNextResults() {
        if (this.uiType == "widget") {
            let promise = this.searchService.nextResults(this.isIe);
            // let promise= this.searchService.nextResults();
            if (promise && !this.isIe) {  //wait for the new results to be loaded and then increment the num of loaded pages
                promise.then(() => {
                    let offset = this.$stateParams['offset'] || 0;
                    let startPage = Math.floor(offset / this.pageSize) + 1;
                    let newPageNum = startPage + this.numOfLoadedPages - 1;
                    this.$timeout(() => {
                        this.smoothScrollUtil.scrollTo('searchResultPage' + newPageNum, null, null);
                    }, 0, false);
                });
            }
        } else if (this.uiType == "picker") {
            let promise = this.searchService.nextResults(true);
        }

    }

    private get numOfLoadedPages() {
        return this.searchService.numOfLoadedResultBulks;
    }

    private getPlaceHolders() {


        return {
            idx_0: this.favoritesService.getTotalItems()
        };
    }


    private getPlaceHoldersForFilter() {
        return {
            idx_0: this.favoritesService.getCountRecords(),
            idx_1: this.favoritesService.getTotalItems()
        };


    }


    public selectAll() {
        this.briefResultService.chooseAll();
    }


    private isExpanded(index) {
        return this.expandedItemIndex === index;
    }

    private setExpandedItem($event, index) {
        if ($event.expand) {
            this.expandedItemHeight = $event.target.parentNode.offsetHeight + 'px';
            this.expandedItemIndex = index;
            this.toggleListBottomSpacer(true);
        } else {
            this.expandedItemHeight = '';
            this.expandedItemIndex = -1;
            this.toggleListBottomSpacer(false);
        }

    }

    private toggleListBottomSpacer(bool) {
        this.listBottomSpacer = bool
    }

    private selectedItemHeight() {
        this.expandedItemHeight;
    }

    get skipLinks() {
        return this.links;
    }

    private getItemOffset(index) {
        // for using old Pagination (for example, Remote search)
        if(this.uiType == "widget"){
            return this.initialOffset + index;
        }
        return this.offset() + index;  // for using the default new pagination 
    }

    private getItemIndex(index) {
        return this.getItemOffset(index) + 1

    }

    private isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    private shouldDisableSavingQuery() {
        let info = this.searchInfo;
        if (info && info.errorDetails && info.errorDetails.errorCode === this.searchErrorMessageService.tooManyClauses) {
            return true;
        }
        return false;
    }

    private showPartialResultsWarning() {
        let info = this.searchInfo;
        if (info && info.errorDetails && this.itemlist.length != 0 && (info.errorDetails.errorCode === this.searchErrorMessageService.blendedTimeout
            || info.errorDetails.errorCode === this.searchErrorMessageService.tooManyClauses
            || info.errorDetails.errorCode === this.searchErrorMessageService.notAllSlicesSearched)) {
            return true;
        }
        return false;
    }

    private showNoResultsErrorMessage() {
        let info = this.searchInfo;
        if (this.resultsExists && info && info.errorDetails && this.itemlist.length != 0 && 
			(info.errorDetails.errorCode === this.searchErrorMessageService.illegalSearchTerm ||
            info.errorDetails.errorCode === this.searchErrorMessageService.crossSystemLimits)) {
            return false;
        }
        return true;
    }

    private onTopOfPageInView(pageNum, $inview, $inviewInfo) {

        let noPaginationPaths = ['/fulldisplay', '/jfulldisplay', '/npfulldisplay'];
        if (noPaginationPaths.indexOf(this.$location.$$path) >= 0) {
            this.wasInFullDisplay = true;
            return;
        }

        if (!$inview) {
            return;
        }

        let halfOfViewport = $inviewInfo.viewportRect.height / 2;
        if ($inviewInfo.elementRect.top < halfOfViewport) {
            if ((this.pageInView !== pageNum && pageNum !== 1 && !this.wasInFullDisplay) || this.needToUpdatePivInSafari) {
                this.pageInView = pageNum;
            }
            this.wasInFullDisplay = false;
            return;
        }
        let offset = this.$stateParams['offset'] || 0;
        let startPage = Math.floor(offset / this.pageSize) + 1;

        if ((!(this.pageInView === startPage)) && (pageNum === this.pageInView) && ($inviewInfo.elementRect.top > halfOfViewport)) {
            this.pageInView--;
        }

        this.wasInFullDisplay = false;
    }

    private onBottomOfPageInView(pageNum, $inview, $inviewInfo) {
        //console.log('bottom of page in view!!!!' + pageNum);
    }

    private isCitationState() {
        return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
    }

    private isSearchState() {
        return this.$state.current.name === STATE_NAMES.SEARCH;
    }

    private isJournalSearchState() {
        return this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH;
    }

    /* Esploro */
    private isOrganizationListState() {
        return this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST;
    }

    private isBrowsHeaderResults() {
        return this.$stateParams ['mode'] === 'browse';
    }

    private notLocal() {
        return !this.searchService.IsScopeLocal();
    }

    private shouldDisplayPagingWidget() {
        return this.$state.current.name === STATE_NAMES.SEARCH || this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH
            || this.$state.current.name === STATE_NAMES.DB_SEARCH || this.$state.current.name === STATE_NAMES.CITATION_TRAILS
            || this.$state.current.name === STATE_NAMES.CITATION_CHAPTERS || this.$state.current.name === STATE_NAMES.NEWSPAPERS
            || this.$state.current.name === STATE_NAMES.ORGANIZATION_LIST;
    }

    get needToUpdatePivInSafari() {
        return this.pageNavMenuService.needToUpdatePivInSafari;
    }

    set needToUpdatePivInSafari(isNeedToUpdate) {
        this.pageNavMenuService.needToUpdatePivInSafari = isNeedToUpdate;
    }

    get pageInView() {
        return this.pageNavMenuService.pageInView;
    }

    set pageInView(updatedPage) {
        this.pageNavMenuService.pageInView = updatedPage;
    }


    get recordsNumberInludeFrbr(): number {
        if (this.$stateParams ['mode'] != 'browse' || this.briefResultService.isSuprima()) {
            return 0;
        }
        let browseResultNumber: number = Number(this.$stateParams['docCount']);
        if (this.searchInfo == undefined) {
            return 0;
        }

        if (this.searchInfo.total >= browseResultNumber || this.inFrbrMode) {
            return 0;
        }
        return browseResultNumber;


    }


    get inFrbrMode(): boolean {
        let facet = this.$stateParams["facet"];
        if (facet == undefined) {
            return false;
        }
        if (facet instanceof Array) {
            for (let temp of facet) {
                if (temp.startsWith("frbrgroupid,")) {
                    return true;
                }
            }
            return false;
        } else {
            return facet.startsWith("frbrgroupid,") ? true : false;
        }
    }

    private displayNewspapersLink() {
        return this.newspapersService.displayNewspapersLink();
    }


    private getDBParamTerm() {
        let term;
        if (this.categoriesType == 'db')
            term = this.$stateParams['databases'];
        if (this.categoriesType == 'journal')
            term = this.$stateParams['journals'];
        if (!term) {
            term = this.$stateParams['query'];
        }
        if (!term) {
            return '';
        }
        term = Array.isArray(term) ? term[0] : term;
        let subterm = term.substring(term.indexOf(',') + 1);
        if (subterm && subterm.length > 0) {
            return subterm;
        } else {
            return term;
        }
    }


    public getDefaultTerm() {
        let dbt = this.getDBParamTerm();
        let dbParamArray = dbt.split(this.databasesCategorizeService.DELIMITER);
        if (dbParamArray && dbParamArray.length > 0) {
            if (this.categoriesType == 'journal')
                return 'nui.journalsearch.category.lvl' + dbParamArray.length + '.' + dbParamArray[dbParamArray.length - 1];
            return dbParamArray[dbParamArray.length - 1];
        } else {
            return dbt;
        }
    }

    public getDynamicTop() {
        let elemHeight: number = document.getElementById('errorCodeMsg').offsetHeight;
        return (elemHeight + 6) + 'px';
    }

    get categoryTerm() {
        if (this.categoriesType == 'journal')
            return this.getDefaultTerm();
        if (this.categoriesType == 'db')
            return 'dbcategories.' + this.databasesCategorizeService.getTName(this.getDBParamTerm());
        else
            return this.databasesCategorizeService.getTName(this.getDBParamTerm());
    }

    public isCategoriesSearch() {
        return this.databasesCategorizeService.isSearchFromCategoryTree();
    }


    private isChaptersAndReviewsState() {
        return this.$state.current.name == STATE_NAMES.CITATION_CHAPTERS;
    }

    private closeMobileFacet($event) {
        this.showMobileFacets = true;
    }

    public openMobileFacets() {
        this.searchService.openCloseMobileFacets();
    }

    get showMobileFacets(): boolean {
        return this.searchService.showMobileFacets;
    }

    set showMobileFacets(value: boolean) {
        this.searchService.showMobileFacets = value;
    }

    get showMobileLabels(): boolean {
        return this.searchService.showMobileLabels;
    }

    set showMobileLabels(value: boolean) {
        this.searchService.showMobileLabels = value;
    }

    private hasSearchResults(): boolean {
        let res = this.searchResults;
        return isArray(res) && res.length > 0;
    }

    // Indication if you are on "PC" scope
    public showPcAvailabilityForScope = memoize(() => {
        let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
        let scope = this.$stateParams['search_scope'];
        return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY');
    });

    // Indication if you are on "PC" scope ("Include Results with no full-text" flag can be on or off)
    public showPcAvailabilityForScopeWithNFT = memoize(() => {
        let map = window.appConfig['primo-view']['pc-availability-tab-scopes-map'];
        let scope = this.$stateParams['search_scope'];
        return some(Object.keys(map), (value) => map[value][scope] === 'AVAILABLE_ONLY' || map[value][scope] === 'INCLUDE_NO_FULL_TEXT');
    });

    public isJournalSearch() {
        return this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH;
    }

    public isDBSearch() {
        return this.databasesService.isDBSearch();
    }

    get isPrimoVE() {
        return this.configurationUtil.getBackendSystem() === 'suprima';
    }

    private setJournalCategoriesByConfiguration() {
        return get(getAttributesMap(), ['journalCategoriesTree'], true);
    }

    public isSearchFromLetters() {
        return this.databasesCategorizeService.isSearchFromLetters();
    }

    public isSearchFromCategoryTree() {
        return this.databasesCategorizeService.isSearchFromCategoryTree();
    }

    public isToolBareEnable() {
        return this.briefResultService.enableOrDisableToolBar;
    }


    private hideDialog() {
        if (this.digestWhenInViewConfigured) {
            this.hideDialogEvent.emit({});
            this.dialogInView = false;
        }

    }

    private showDialog() {
        if (this.digestWhenInViewConfigured) {
            this.showDialogEvent.emit({});
            this.dialogInView = true;
        }

    }

    get totalResults() {
        if (this.resultsExists) {
            return this.searchService.getResultObject().info.total;
        } else {
            return 0;
        }
    }

	    get maxDisplayResults() {
		        return 2000;
	    }
	
    public isOrgListSearch() {
        return this.orgListService.isOrgListSearch();
    }

    public isShowingOrganizationTree() {
        //false - will show the facet
        return this.organizationOrFacetService.isOrganizationTree;
    }

    public showFacetSection() {
        // the $stateParams can be either "journals" or "databases" but not both
        if (this.$stateParams["journals"] || this.$stateParams["databases"]) {
            let conditionIndication = this.$stateParams["journals"] || this.$stateParams["databases"];
            return conditionIndication.split(",")[0] != "letter";
        } else if (this.isOrgListSearch()) {
            return !this.isShowingOrganizationTree();
        } else {
            return true;
        }
    }

    public isSearchFromBarDBorJournals() {
        return this.databasesCategorizeService.isSearchFromBarDBorJournals();
    }

    getItems() {
        return this.favoritesService.getItems();
    }

    private mobileLabels() {
        this.showMobileLabels = !this.showMobileLabels;
        if (this.showMobileLabels == true) {
            let element = document.querySelector('prm-favorites md-tab-content');
            element.style.display = 'inline';
        }
    }

    // To unselect checked records
    private unselectSelectedRecords() {
        this.briefResultService.resetIsChosen();
    }

    public pickBulkSize(selectedBulk) {
        let searchObject = this.searchService.getSearchObject();
        let args = this.searchStateService.getSearchObject();
        args.bulkSize = selectedBulk.bulkSize;
        args.offset = 0;
        args.to = selectedBulk.bulkSize;
        this.$location.search('offset', 0);
        this.pageNavMenuService.pageInView = 1;
        this.unselectSelectedRecords();
        this.searchStateService.setSearchObject(searchObject);
        this.searchService.search(args, true);
        this.initialOffset = 0;
    }

    get selectedLabels(){
        return this.favoritesService.getselectedLabels();
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/searchResult.directive.ts